import { render, staticRenderFns } from "./Type9a.vue?vue&type=template&id=057223bc&"
import script from "./Type9a.vue?vue&type=script&lang=js&"
export * from "./Type9a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports